import type { ElementType, ReactNode } from 'react';

import { cn } from '@/design-system';

/**
 * Kaarttitel als echte kop. `CardHeader` uit het design system zet de titel in
 * een `div`; op deze schermen zijn het koppen, zodat een schermlezer door het
 * scherm kan springen.
 *
 * TODO(agent: design-system): overweeg een `as`-prop op `CardHeader`.
 */
export function CardTitle({
    children,
    as,
    className,
}: {
    children: ReactNode;
    as?: ElementType;
    className?: string;
}) {
    const Tag = (as ?? 'h2') as ElementType;

    return (
        <Tag
            className={cn(
                'm-0 font-[family-name:var(--font-display)] text-[15px] font-semibold leading-[1.3] text-[var(--text-primary)]',
                className,
            )}
        >
            {children}
        </Tag>
    );
}

/** Kopregel van een kaart waarin rijen tot de rand lopen: titel links, actie rechts. */
export function CardTitleRow({ title, action }: { title: ReactNode; action?: ReactNode }) {
    return (
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-[var(--border-subtle)] px-4 py-[14px]">
            <CardTitle>{title}</CardTitle>
            {action ? <div className="flex shrink-0 items-center gap-2">{action}</div> : null}
        </div>
    );
}
